// TODO - remove lint disable when editing this file
/* eslint-disable */
import { fromJS } from 'immutable'
import ArcUUID from '~/util/arc-identifiers'

export default class BaseConverter {
  constructor(ansType, draftTypes) {
    this._ansType = ansType
    this._draftTypes = draftTypes
  }

  getAnsType() {
    return this._ansType
  }

  getDraftTypes() {
    return this._draftTypes
  }

  shouldAggregate(blocks, nextBlock) {
    return false
  }

  setMetaData(element, blocks, context) {
    return blocks.map((block) => {
      const metaData = {}
      metaData.id = element._id
      metaData.alignment = element.alignment || ''
      // When channels is undefined, it means all channels, but since undefined can't tell if the value
      // has actually been set or it's just new, use null here instead.
      metaData.channels = element.channels || null
      if (element.additional_properties) {
        metaData.additionalProperties = element.additional_properties
      }
      if (element.subtype) {
        metaData.subtype = element.subtype
      }
      if (element.block_properties) {
        metaData.blockProperties = element.block_properties
      }
      return context.setAnsElementMetaData(block.getKey(), fromJS(metaData))
    })
  }

  appendAndGetBlocks(element, context) {
    return context.appendAtomicBlock(element)
  }

  toBlocks(element, context) {
    const blocks = this.appendAndGetBlocks(element, context) || []
    return this.setMetaData(element, blocks, context)
  }

  withDefaultData(data) {
    const result = {}
    if (data.alignment) {
      result.alignment = data.alignment
    }
    if (data.channels) {
      result.channels = data.channels
    }
    if (data.additionalProperties) {
      result.additional_properties = data.additionalProperties
    }
    if (data.blockProperties) {
      result.block_properties = data.blockProperties
    }
    if (data.subtype) {
      result.subtype = data.subtype
    }
    result._id = data.ansId || data.id || ArcUUID.create()
    return result
  }

  populateMetaData(ansData, [block]) {
    if (ansData) {
      const blockData = block.getData().toJS()
      return Object.assign({}, ansData, this.withDefaultData(blockData))
    }

    return ansData
  }

  toAnsDataFromBlocks(contentState, [block]) {
    // Atomics should manage ANS item by itself. Here we just get ANS data from block and return it back
    const blockData = block.getData()
    if (!blockData || !blockData.get('ans')) {
      console.warn(
        `Unable to convert atomic block ${block.getKey()}. No ANS data.`
      )
      return null
    }

    return blockData.get('ans')
  }

  toAns(contentState, blocks) {
    const data = this.populateMetaData(
      this.toAnsDataFromBlocks(contentState, blocks),
      blocks
    )

    if (data.type === 'header') {
      delete data?.block_properties
    }
    return data
  }
}
